import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Row, Col } from "react-bootstrap";
import moment from "moment";
import ReactPaginate from "react-paginate";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { buildOptions } from "../utils";
import { isEqual } from "lodash";
import withFetchHook from "../withFetchHook";
import classnames from "classnames";

class CheckinsTab extends Component {
  state = {
    currentPage: 1,
    startDate: null,
    endDate: null,
    type: null,
  };

  componentDidMount() {
    if (this.props.isActive) {
      this.fetchCheckins();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { isActive } = this.props;
    if (isActive && (!isEqual(prevState, this.state) || prevProps.isActive !== isActive)) {
      this.fetchCheckins();
    }
  }

  fetchCheckins() {
    const { organizationName, residentId, isActive } = this.props;
    const { currentPage, startDate, endDate, type } = this.state;
    
    if (!isActive) return;

    this.props
      .fetch(`/organizations/${organizationName}/checkins.json`, {
        data: {
          page: currentPage,
          by_start_date: startDate,
          by_end_date: endDate,
          by_kind: type,
          by_resident: residentId,
        },
      })
      .then((checkins) => {
        this.props.updateCheckins(checkins);
      });
  }

  renderPagination() {
    const { total_pages } = this.props.checkins;
    const { currentPage } = this.state;

    return (
      <ReactPaginate
        containerClassName="pagination"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        activeClassName="active"
        pageCount={total_pages}
        onPageChange={(page) =>
          this.setState({ currentPage: page.selected + 1 })
        }
      />
    );
  }

  render() {
    const { organizationName, isStaffApp, resident, config } = this.props;
    const { checkins } = this.props.checkins;
    const { startDate, endDate, type } = this.state;
    const typeOptions = buildOptions([
      ["house", "House"],
      ["meeting", "Meeting"],
      ['curfew', 'Curfew'],
      ["other", "Other"],
    ]);
    const typeValue = typeOptions.find((option) => option.value === type);
    const senderUrl = `${config.root_url}organizations/${organizationName}/residents/${resident.id}`;
    const hrefOf = (checkin) =>
      `${config.root_url}organizations/${organizationName}/checkins/${checkin.id}/edit?sender=${senderUrl}&sender_name=${resident.name}`;

    return isStaffApp ? (
      <>
        {checkins.map((checkin) => (
          <a
            key={checkin.id}
            href={hrefOf(checkin)}
            className="d-block text-black clickable border-bottom p-4"
          >
            <div className="d-flex justify-content-between align-items-center pb-1">
              <b className="text-capitalize">{checkin.name}</b>
              <div
                className={classnames("badge text-uppercase", {
                  "badge-danger": checkin.state == "rejected",
                  "badge-success": checkin.state == "approved",
                  "badge-warning": checkin.state == "pending",
                  "badge-secondary": !checkin.checked_out_at,
                })}
              >
                {!!checkin.checked_out_at ? checkin.state : "current"}
              </div>
            </div>
            <div>{checkin.full_street_address}</div>
            <div className="text-secondary">
              {moment(checkin.checked_in_at).format("MM/DD/YYYY hh:mma")} -{" "}
              {moment(checkin.checked_out_at).format("MM/DD/YYYY hh:mma")}
            </div>
          </a>
        ))}
        <div className="d-flex justify-content-center mt-4">
          {this.renderPagination()}
        </div>
      </>
    ) : (
      <div>
        <div className="d-flex flex-wrap justify-content-center mb-2">
          <div className="mr-2">
            <DatePicker
              className="form-control"
              placeholderText="Start Date"
              selected={startDate ? moment(startDate) : null}
              onChange={(date) => {
                this.setState({
                  startDate: date ? moment(date).format("YYYY-MM-DD") : null,
                });
              }}
            />
          </div>
          <div className="mr-2">
            <DatePicker
              className="form-control"
              placeholderText="End Date"
              selected={endDate ? moment(endDate) : null}
              onChange={(date) => {
                this.setState({
                  endDate: date ? moment(date).format("YYYY-MM-DD") : null,
                });
              }}
            />
          </div>
          <div className="mr-2" style={{ minWidth: 250 }}>
            <Select
              placeholder="Type"
              options={typeOptions}
              width={400}
              styles={{
                menu: provided => ({ ...provided, zIndex: 9999 })
              }}
              isClearable
              value={typeValue}
              onChange={(option) => {
                this.setState({ type: option ? option.value : null });
              }}
            />
          </div>
        </div>
        {this.renderPagination()}
        <Row>
          {checkins.map((checkin, i) => {
            return (
              <Col xs={12} sm={6} key={i}>
                <Card style={{ flexDirection: "row", alignItems: "center" }}>
                  <div className="card-block">
                    <strong>Check in: </strong>
                    <span>{checkin.name}</span>
                    <br />
                    <strong>State: </strong>
                    <span>{checkin.state}</span>
                    <br />
                    <strong>Type: </strong>
                    <span>{checkin.kind}</span>
                    <br />
                    {!!checkin.event && (
                      <>
                        <strong>Event: </strong>
                        <span>
                          <a
                            target="_blank"
                            href={`/organizations/${organizationName}/events/${checkin.event.id}?starts_at=${checkin.event.starts_at}&ends_at=${checkin.event.ends_at}`}
                          >
                            {checkin.event.title}
                          </a>
                        </span>
                        <br />
                      </>
                    )}
                    <strong>Location: </strong>
                    <span>{checkin.full_street_address}</span>
                    <br />
                    <strong>Time in: </strong>
                    <span>
                      {checkin.checked_in_at &&
                        moment(checkin.checked_in_at).format(
                          "MMMM Do YYYY h:mm:ss a"
                        )}
                    </span>
                    <br />
                    <strong>Time out: </strong>
                    <span>
                      {checkin.checked_out_at &&
                        moment(checkin.checked_out_at).format(
                          "MMMM Do YYYY h:mm:ss a"
                        )}
                    </span>
                    <br />
                    <strong>Length of time spent: </strong>
                    <span>
                      {checkin.checked_in_at &&
                        checkin.checked_out_at &&
                        moment(checkin.checked_in_at).from(
                          checkin.checked_out_at,
                          true
                        )}
                    </span>
                    <br />
                    <strong>Checked out and went: </strong>
                    <span>{checkin.destination}</span>
                    <br />
                    {checkin.notes && (
                      <>
                        <strong>Notes: </strong>
                        <span>{checkin.notes}</span>
                        <br />
                      </>
                    )}
                    <a
                      href={`/organizations/${organizationName}/checkins/${checkin.id}/edit`}
                    >
                      Edit
                    </a>
                  </div>
                  {checkin.image_url && !checkin.image_url.includes("missing") && (
                    <Col xs={12} sm={6} key={`${i}-image`}>
                      <img src={checkin.image_url} style={{ width: "100%" }} />
                    </Col>
                  )}
                </Card>
              </Col>
            );
          })}
        </Row>
        {this.renderPagination()}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isStaffApp: state.config.isStaffApp,
    checkins: state.checkins,
    organizationName: state.organization.name,
    residentId: state.resident.id,
    resident: state.resident,
    config: state.config,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCheckins: (checkins) =>
      dispatch({ type: "UPDATE_CHECKINS", payload: { checkins } }),
    updatePage: (currentPage) =>
      dispatch({ type: "UPDATE_CURRENT_PAGE", payload: { currentPage } }),
  };
};

export default withFetchHook(
  connect(mapStateToProps, mapDispatchToProps)(CheckinsTab)
);
